import { useEffect, useState } from "react";

// Column show/hide state persisted in localStorage as the list of *hidden* keys,
// so columns added later default to visible.
export default function useColumnVisibility(storageKey, allColumns, defaultHiddenKeys = []) {
  const [visibleColumns, setVisibleColumns] = useState(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      if (raw) {
        const hidden = JSON.parse(raw);
        if (Array.isArray(hidden)) {
          const visible = allColumns.map((c) => c.key).filter((k) => !hidden.includes(k));
          if (visible.length > 0) return new Set(visible);
        }
      }
    } catch {}
    return new Set(allColumns.map((c) => c.key).filter((k) => !defaultHiddenKeys.includes(k)));
  });

  useEffect(() => {
    try {
      localStorage.setItem(
        storageKey,
        JSON.stringify(allColumns.map((c) => c.key).filter((k) => !visibleColumns.has(k))),
      );
    } catch {}
  }, [visibleColumns, storageKey, allColumns]);

  const toggleColumn = (key) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const visibleColumnDefs = allColumns.filter((c) => visibleColumns.has(c.key));

  return { visibleColumns, toggleColumn, visibleColumnDefs };
}
